import React, {createContext, ReactNode} from "react";


type InternalContextType = {
    renderActionButton: ReactNode;
    setRenderActionButton: (renderActionButton: ReactNode) => void;
};

export const InternalContext = createContext<InternalContextType>({
    renderActionButton: null,
    setRenderActionButton: () => {}
});

export function InternalProvider({children}: { children: ReactNode}) {
    const [renderActionButton, setRenderActionButton] = React.useState<ReactNode>(null);
    const provider: InternalContextType = {
        renderActionButton,
        setRenderActionButton: (newRenderActionButton) => {
            setRenderActionButton(newRenderActionButton);
        }
    };

    return <InternalContext.Provider value={provider}>{children}</InternalContext.Provider>;
}

export const useInternalContext = () =>React.useContext(InternalContext);
